module.exports = __webpack_public_path__ + "static/img/low-profile-pedestal-posts.51aacb0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/general-frames/low-profile-pedestal-posts.jpg
// module id = 727
// module chunks = 0